import { ISusuarioList, UsuarioList } from '../../../../../types/usuario/UsuarioList';
import { IStipoPublicacaoOficialList, TipoPublicacaoOficial, TipoPublicacaoOficialList } from '../../../../../typesSite/tipoPublicacaoOficial/TipoPublicacaoOficial';
import { VereadorList } from '../../../../../typesSite/vereador/Vereador';

export interface PublicacaoOficial {
  id?: string;
  tipo: TipoPublicacaoOficialList;
  descricao: string;
  observacao: string;
  exercicio: number | null; 
  dataHoraCriacao?: Date | string;
  usuario?: UsuarioList;
}
export const ISpublicacaoOficial: PublicacaoOficial = {
  id: '',
  tipo: IStipoPublicacaoOficialList,
  descricao: '',
  observacao: '',
  dataHoraCriacao: '',
  exercicio: null,
  usuario: ISusuarioList
};
export interface PublicacaoOficialList {
  id?: string;
  tipo: TipoPublicacaoOficialList;
  vereadores: VereadorList[];
  descricao: string;
  observacao: string;
  dataHoraCriacao?: Date | string;
  exercicio: number | null; 
  usuario: UsuarioList;
  temAnexo: boolean;
}
export const ISpublicacaoOficialList: PublicacaoOficialList = {
  id: '',
  tipo: IStipoPublicacaoOficialList,
  vereadores: [],
  descricao: '',
  observacao: '',
  dataHoraCriacao: '',
  exercicio: null,
  usuario: ISusuarioList,
  temAnexo: false
};

export interface PublicacaoOficialDTO {
  id: string;
  idTipo: string;
  descricao: string;
  observacao: string;
  exercicio: number | null; 
}
export const ISpublicacaoOficialDTO: PublicacaoOficialDTO = {
  id: '',
  idTipo: '',
  descricao: '',
  observacao: '',
  exercicio: null
};

export interface PublicacaoOficialListPublicResponse {
  results: PublicacaoOficialList[];
  count: number;
  next: string | null;
  previous: string | null;
}
